<template>
  <el-container style="height:100%">
    <el-aside width="50%" v-show="show">
      <div class="left">
        <el-input class="importmsg" type="textarea" readonly v-model="msg" :rows="20"></el-input>
      </div>
    </el-aside>
    <el-main>
      <div class="right">
        <el-upload
          class="upload-demo"
          ref="upload"
          drag
          :action="upUrl"
          multiple
          :auto-upload="true"
          :limit="1"
          :on-success="handleSuccess"
          :headers="headers"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件,请点击
            <el-link type="primary" :href="templateurl">下载模板</el-link>
          </div>
        </el-upload>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import config from "../../../api/config";
export default {
  data() {
    return {
      show: false,
      msg: "提示信息",
      templateurl: config.staticURL + "/data/import_reguser.xlsx",
      upUrl: config.baseURL + "/api/gm/userextend/import/4",
      headers: {
        Authorization: "Bearer " + this.$store.getters.token
      }
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.$message({
          message: "数据导入成功!",
          type: "success",
          duration: 2000,
          onClose: () => {
            this.$router.go(0);
          }
        });
      } else {
        this.show = true;
        this.$refs.upload.clearFiles();
        this.msg = response.msg;
        this.$alert("导入失败,请查看右边错误信息", "错误", {
          confirmButtonText: "确定",
          type: "error"
        });
      }
    }
  }
};
</script>

<style scoped>
.importmsg {
  margin-bottom: 10px;
}
.left {
  padding: 20px 10px;
}
.right {
  margin-top: 20vh;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/gm/userextend/import.vue